import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, Button } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import moment from 'moment'

class AddLessonsToCourseDialog extends Component {

    state = {
        value: false
    }

    handleChange = event => {
        this.setState({ value: event.target.value })
    }

    closeModal = (event, bool, start, course_id, clickAway) => {
        this.setState({ value: false })
        this.props.closeDialogState(event, bool, start, course_id, clickAway)
    }

    render() {
        const { classes, start, courses } = this.props

        const courseChoices = courses
            .map(course => {
            return (
                <FormControlLabel 
                    value={course.company_calendar_course_id.toString()} 
                    control={<Radio/>} 
                    label={course.CourseName + ' - ' + moment(course.StartDate).format('MM/DD/YYYY')}
                    key={course.company_calendar_course_id}
                />
            )
        })

        return (
            <Dialog
                open={this.props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.closeModal({}, false, null, 0, true)}
            >
                <DialogTitle>Add to existing course?</DialogTitle>
                <DialogContent>
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <p>*Adding to a course will overwrite lessons should they be dropped on the same day</p>
                            <FormControl component="fieldset" className={classes.formControl}>
                                <FormLabel component="legend">Courses</FormLabel>
                                <RadioGroup
                                    aria-label="Gender"
                                    name="gender1"
                                    className={classes.group}
                                    value={this.state.value}
                                    onChange={this.handleChange}
                                >
                                {courseChoices}
                                </RadioGroup>
                            </FormControl>
                            
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.closeModal(this.props.event, true, start, this.state.value)}
                                disabled={!this.state.value}
                            >Add To Course
                            </Button>
                        </Grid>
                        {/* <Grid item xs={6}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.closeModal(this.props.event, false, start, this.state.value)}
                            >Add Independently
                            </Button>
                        </Grid> */}
                    </Grid>

                </DialogContent>
            </Dialog>
        )
    }
}

export default AddLessonsToCourseDialog;


// WEBPACK FOOTER //
// src/main/content/company/CompanyCalendar/AddLessonsToCourseDialog.js